import type { MusinsaStandardResponse } from '@musinsa/packages-http';
import { z } from 'zod';

const PeriodInfoSchema = z.object({
  firstDay: z.string(),
  lastDay: z.string(),
  isConfirmed: z.boolean(),
});

const OrderAmountInfoSchema = z.object({
  totalAmount: z.number().int(),
  directAmount: z.number().int(),
  indirectAmount: z.number().int(),
  exclusiveAmount: z.number().int(), // 단독 상품 주문 금액
});

const OrderCountInfoSchema = z.object({
  totalCount: z.number().int(),
  directCount: z.number().int(),
  indirectCount: z.number().int(),
  exclusiveCount: z.number().int(), // 단독 상품 주문 건수
});

const EarningsInfoSchema = z.object({
  totalEarnings: z.number().int(),
});

const DetailPerformanceSchema = z.object({
  earnings: EarningsInfoSchema,
  orderAmount: OrderAmountInfoSchema,
  orderCount: OrderCountInfoSchema,
  visitCount: z.number().int(),
});

const BoostingPerformanceSchema = z.object({
  promotionName: z.string(),
  promotionPeriod: z.string(),
  additionalCommissionRate: z.number(),
  expectedBoostingEarnings: z.number().int(),
});

export const MonthlyRevenueResponseSchema = z.object({
  period: PeriodInfoSchema,
  totalOrderCount: z.number().int(),
  totalOrderAmount: z.number().int(),
  totalEarnings: z.number().int(),
  totalVisitCount: z.number().int(),
  goods: DetailPerformanceSchema,
  curatorShop: DetailPerformanceSchema,
  boostingPerformance: BoostingPerformanceSchema.nullable().optional(),
});

/**
 * 월별 수익 조회 요청 스키마
 */
const GetMonthlyRevenueRequestSchema = z.object({
  year: z.number().int(),
  month: z.number().int().min(1).max(12),
});

export type GetMonthlyRevenueRequestParams = z.infer<typeof GetMonthlyRevenueRequestSchema>;
export type GetMonthlyRevenueResponse = MusinsaStandardResponse<
  z.infer<typeof MonthlyRevenueResponseSchema>
>;
